import React from 'react'
import { useTheme } from 'next-themes'
import { Toaster as Sonner } from 'sonner'
import { Spinner } from '@/components/ui/spinner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme()

  return (
    <Sonner
      // D-N-052: top placement avoids overlap with bottom-anchored dialog
      // footers (e.g. ResponsiveDialog mobile drawer). An update toast
      // at bottom-center was intercepting touches intended for Cancel,
      // which fired Continue and committed a partial maintenance scan.
      position="top-center"
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      // The app's one spinner for toast.loading too (ShadCN's sonner does the same)
      icons={{ loading: <Spinner /> }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
